import React from "react";
import i18n from "i18next";
import CurrencyInput from "react-currency-input-field";

import { currencyValidOrDefault } from "../../../../../shared/i18n";

const CurrencyInputCustom = ({ inputRef, onChange, ...props }) => {
  return (
    <div className={`MuiFormControl-root MuiTextField-root ${props.className}`}>
      <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled">
        {props.label}
      </label>
      <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl">
        <CurrencyInput
          {...props}
          name="price"
          className={`MuiInputBase-input MuiInput-input`}
          intlConfig={{
            locale: i18n.language,
            currency: currencyValidOrDefault(props.currency),
          }}
          decimalsLimit={2}
          onValueChange={(value) => onChange(value)}
        />
      </div>
    </div>
  );
};

export default CurrencyInputCustom;
